import {request} from "services/api/util";

class MembershipService {
    async getMemberships(param) {
        const config = {
            method: "get",
            url: `admin/memberShipTier`,
            params: param,
            headers: {
                "content-type": "application/json;charset=UTF-8",
            },
        };
        return request(config);
    }

    async getDetailMembership(id) {
        const config = {
            method: "get",
            url: `admin/memberShipTier/${id}`,
            headers: {
                "content-type": "	application/json;charset=UTF-8",
            },
        };
        return request(config);
    }

    async createOrUpdateMembership(body, id, update) {
        let config;
        if (update) {
            config = {
                method: "put",
                url: `admin/memberShipTier/${id}`,
                data: body,
                headers: {
                    "content-type": "application/json;charset=UTF-8",
                },
            };
        } else {
            config = {
                method: "post",
                url: `admin/memberShipTier`,
                data: body,
                headers: {
                    "content-type": "application/json;charset=UTF-8",
                },
            };
        }

        return request(config);
    }
}
export default new MembershipService();
